import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//import { loginGuard, logOutGuard } from '@core/guards';
import { authApiGuard, noAuthApiGuard } from '@core/guards';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [noAuthApiGuard],
  },
  {
    path: '',
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    canActivate: [authApiGuard],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
